<template>
    <div>
        <div class="feedback-btn">
            <!--<v-btn class="rounded-b-xl shepherd-feedback-button" dark width="150px" color="#134679" tile @click="isFeedbackDialogOpen = true"> Feedback </v-btn>-->
            <v-btn class="rounded-b-xl shepherd-feedback-button" dark width="150px" color="#006DB6" tile @click="isFeedbackDialogOpen = true"> Feedback </v-btn>
        </div>
        <app-dialog :value="isFeedbackDialogOpen" @input="isFeedbackDialogOpen = $event" :title="$t('feedback.title')" data-cy="app-dialog" :width="getDialogWidth">
            <template v-slot:content>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12" class="px-2 pb-0">
                            <p class="font-size-lg description-text">{{ $t('feedback.question1') }}</p>
                        </v-col>
                    </v-row>
                    <div class="d-flex justify-center mt-5">
                        <!--<v-rating background-color="#154579" color="#154579" size="50" v-model="feedbackForm.rating"></v-rating>-->
                        <v-rating background-color="#006DB6" color="#006DB6" size="50" v-model="feedbackForm.rating"></v-rating>
                    </div>
                    <v-row>
                        <v-col sm="12" md="12" class="px-2 pb-0 mt-6">
                            <p class="font-size-lg description-text">{{ $t('feedback.question2') }}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col sm="12" md="12" class="px-2 pb-0">
                            <v-textarea :label="$t('feedback.placeholder')" v-model="feedbackForm.message" hide-details dense no-resize rows="5"></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:buttons="{}">
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                        <v-btn text outlined class="myprovet-btn-cancel" @click="isFeedbackDialogOpen = false" data-cy="app-dialog-cancel-btn"> {{ $t('common.cancel') }} </v-btn>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                        <v-btn text class="myprovet-btn-ok" @click="submitForm()" :loading="loading" data-cy="app-dialog-submit-btn"> {{ $t('sendAccount.send') }} </v-btn>
                    </v-col>
                </v-row>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { axios } from '@/Services/Backend';

export default {
    name: 'FeedbackButton',

    data: () => ({
        isFeedbackDialogOpen: false,

        loading: false,

        feedbackForm: {
            rating: null,
            message: null,
        },
    }),

    computed: {
        getDialogWidth() {
            return this.getResponsiveDialogWidth('80vw', '530px');
        },
    },

    methods: {
        submitForm() {
            this.loading = true;

            axios
                .post('/api/feedback', this.feedbackForm)
                .then(() => {
                    this.loading = false;

                    this.showSuccess(this.$t('feedback.sent'));

                    this.isFeedbackDialogOpen = false;
                    this.feedbackForm.rating = null;
                    this.feedbackForm.message = null;
                })
                .catch((error) => {
                    // @Note: We will only ever have this error.
                    const errors = error.response.data.errors;
                    const rating = errors.rating[0] ?? this.$t('feedback.invalidRating');

                    this.showError(rating);

                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.feedback-btn {
    position: fixed;
    width: 100px;
    height: 30px;
    left: 100%;
    top: 50%;
    transform-origin: 0% 0%;
    transform: rotate(90deg) translateX(-50%);
}

p {
    /*color: #154579 !important;*/
    color: #006DB6 !important;
}
</style>

<style>
@media only screen and (max-width: 1259px) {
    .shepherd-feedback-button {
        height: 25px !important;
        padding-top: 4px !important;
    }
}
</style>
